import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MenuComponent } from './menu/menu.component';
import { VideosComponent } from './videos/videos.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { VideoDetailComponent} from './video-detail/video-detail.component';
import { LoginPageComponent } from './guest/login-page/login-page.component';
import { RegisterComponent} from  './guest/register/register.component';
import { PasswordResetComponent } from './guest/password-reset/password-reset.component';
import { NoMenuComponent } from './no-menu/no-menu.component';
import { NoMenuDashboardComponent } from './no-menu-dashboard/no-menu-dashboard.component';
import { SettingsComponent } from './settings/settings.component';


import { AuthGuard } from './guards/auth.guard';
import { NewPasswordComponent } from './guest/new-password/new-password.component';

const routes: Routes = [
  //NoMenuDashboardComponent
  {path: '', component: NoMenuDashboardComponent, canActivate: [AuthGuard], children: [
    {path: '', component: DashboardComponent},
    {path: 'dashboard', component: DashboardComponent},
  ]
  },
  {path: '', component: MenuComponent, canActivate: [AuthGuard], children: [
    {path: 'videos/:id', component: VideosComponent},
    {path: 'detail/:id', component: VideoDetailComponent},
    {path: 'settings', component: SettingsComponent}
  ]
  },
  {path: '', component: NoMenuComponent, children: [
    {path: '', component: LoginPageComponent},
    {path: 'login-page', component: LoginPageComponent},
    {path: 'register', component: RegisterComponent},
    {path: 'password-reset', component: PasswordResetComponent},
    {path: 'new-password', component: NewPasswordComponent},
  ]}
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [ RouterModule ]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts